export const toggleStringElement = (array: Array<string>, element: string): Array<string> => {
  const newArray = array.filter(item => item !== element);

  if (newArray.length === array.length) {
    newArray.push(element);
  }

  return newArray;
};
